import React from "react";
import Blog from "../Components/blog";
import Sarita from "../details";

const MyBlogs = () => {
    return (
        <>
            <Blog props={Sarita}/>
        </>
    )
}

export default MyBlogs;